import classNames from 'classnames';
import {isEmpty} from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchUser} from '../../../../../actions/entities/user';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';

export const editUserOptins = (userId, optins, onSuccess = () => {}) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('editUserOptins', userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify(optins),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
        } else {
          onSuccess();
          dispatch(fetchUser({identifier: userId}));
        }
      })
      .catch(error => {
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong !<br/>${error}<br/>`,
        });
      });
  };
};

const UserOptins = ({user, dispatch}) => {
  return (
    <div>
      <SupportTitle title="Optins" />
      <table className="table table-sm table-responsive table-striped">
        <thead>
          <tr>
            <th>Key</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {!isEmpty(user.optins) &&
            Object.keys(user.optins).map(optinId => (
              <TableRow
                key={optinId}
                label={optinId}
                value={
                  <i
                    style={{color: 'black'}}
                    onClick={() =>
                      dispatch(
                        editUserOptins(user.id, {
                          ...user.optins,
                          [optinId]: user.optins[optinId] === 1 ? 0 : 1,
                        }),
                      )
                    }
                    className={classNames('fa fa-2x', {
                      'fa-toggle-on': user.optins[optinId],
                      'fa-toggle-off': !user.optins[optinId],
                    })}
                  />
                }
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserOptins);



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Optins/index.js